module.exports = require('../dist/components/Divider/Divider');
